import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-16/task-01";

const task: Slide = {
  titleHtml: "In the useful frequency range, the sensitivity of<br>an omnidirectional condenser microphone is:",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
